<template>
  <div>
    <LeftSidebar
      :visible="visible"
      baseClass="add-term-wrapper"
      :title="$lang.addNewTermState"
      :hasHeaderRightIcon="false"
    >
      <template>
        <TermStateForm
          v-if="visible"
          :submitted="submitted"
          @setParameters="setParameters"
          @setSubmitted="setSubmitted"
          @handleSubmit="handleSubmit"
        />
      </template>
      <template #footer>
        <Button
          variant="filled-complementary"
          :text="$lang.cancel"
          class="mobile-width-percent-100 tablet-width-percent-100"
          contentClass="justify-content-center"
          @click="handleClose"
        />
        <Button
          variant="primary"
          :text="$lang.submit"
          class="mobile-width-percent-100 tablet-width-percent-100"
          contentClass="justify-content-center"
          :loading="loading"
          @click="setSubmitted(true)"
        />
      </template>
    </LeftSidebar>
  </div>
</template>

<script>
import LeftSidebar from "@/components/re-design/sidebar/LeftSidebar.vue";
import { Button } from "@/components/re-design/forms";
import TermStateForm from "./forms/TermStateForm.vue";
import { addTermState } from "@/modules/profile/services";
import { inject, ref, toRefs } from "vue";
import { generateError, toastAlert } from "@/shared/utils";

export default {
  components: { LeftSidebar, TermStateForm, Button },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    // generate props data
    const { visible } = toRefs(props);

    const handleClose = () => emit("handleClose");
    const handleFetchData = () => emit("handleFetchData");

    const loading = ref(false);
    const termCode = inject("TERM_CODE");
    const parameters = ref({});
    const setParameters = (params) =>
      (parameters.value = { termCode, ...params });
    const submitted = ref(false);
    const setSubmitted = (value) => (submitted.value = value);
    const handleSubmit = async () => {
      try {
        loading.value = true;
        const response = await addTermState(parameters.value);
        const { message } = response;
        toastAlert(message);
        handleClose();
        handleFetchData();
      } catch (error) {
        generateError(error);
      } finally {
        loading.value = false;
      }
    };

    // return data to be used in template
    return {
      visible,
      loading,
      parameters,
      submitted,
      handleClose,
      setParameters,
      setSubmitted,
      handleSubmit,
    };
  },
};
</script>
